<template>
  <div>
    <Table
      class="expand-table-child"
      :show-header="false"
      style="border:0"
      ref="selection"
      :columns="columns4"
      :data="rows"
    >
      <template slot-scope="{ row }" slot="action">
        <div style="text-align:right;padding-right:7px;">
          <Button @click="editClassify(row)" type="text" size="small">编辑</Button>-
          <Button @click="close(row)" type="text" size="small">{{row.status == 1 ?'关闭':'开启'}}</Button>-
          <Button @click="deleteClassify(row)" type="text" size="small">删除</Button>
        </div>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  props: {
    row: Object
  },
  data() {
    return {
      columns4: [
        {
          type: "expand",
          align: "center",
          minWidth: 40
        },
        {
          title: "导航名称",
          key: "name",
          align: "center",
          minWidth: 180
        },
        {
          title: "链接地址",
          key: "url",
          minWidth: 130,
          align: "center"
        },
        {
          title: "新窗口",
          key: "is_target_name",
          minWidth: 100,
          align: "center"
        },
        {
          title: "链接类型",
          key: "is_outer_name",
          align: "center",
          minWidth: 180
        },
        {
          title: "状态",
          key: "status_name",
          minWidth: 100,
          align: "center"
        },
        {
          title: "顺序",
          key: "sort",
          minWidth: 100,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 240,
          fixed: "right"
        }
      ],
      ruleValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }]
      },
      addClassifyModal: false,
      modalText: "新增分类",
      addClassifyInfo: {}
    };
  },
  mounted() {},
  computed: {
    rows() {
      this.row.children.forEach(i => {
        i._disableExpand = true;
      });
      return this.row.children;
    }
  },
  methods: {
    deleteClassify(row) {
      this.$emit("onDel", row);
    },
    editClassify(row) {
      this.$emit("onAdd", row);
    },
    close(row) {
      this.$emit("close", row);
    }
  }
};
</script>

<style>
.website-page .ivu-table-expanded-cell {
  padding: 0 !important;
}
</style>
